import { useEffect, useState } from "react";
import httpClient from "../HTTPService";
import moment from "moment";
import { Tooltip as ReactTooltip } from "react-tooltip";
import 'react-tooltip/dist/react-tooltip.css'
import { useNavigate } from "react-router-dom";

function Reports() {
    const [rportsList, setReportslist] = useState([])
    const [searchtext, setsearchtext] = useState('')
    const [totalCount, setTotalCount] = useState(0)
    const [currentPage, setCurrentPage] = useState(1);
    const [getLimit, setLimit] = useState(10);
    const items = Array.from({ length: totalCount }, (_, index) => `Item ${index + 1}`);
    const itemsPerPage = 10;
    const totalPages = Math.ceil(items.length / getLimit);
    const startPage = Math.max(1, currentPage - Math.floor(5 / 2));
    const endPage = Math.min(totalPages, currentPage + Math.floor(5 / 2));
    const [weeklyData, setweeklyData] = useState([])
    useEffect(() => {
        getreports(searchtext, currentPage, getLimit);
    }, [currentPage, getLimit]);
    const navigate = useNavigate();

    const [activeWeekly, setactiveweek] = useState('')
    const monthMap = {
        Jan: 1,
        Feb: 2,
        Mar: 3,
        Apr: 4,
        May: 5,
        Jun: 6,
        Jul: 7,
        Aug: 8,
        Sep: 9,
        Oct: 10,
        Nov: 11,
        Dec: 12
    };
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };
    //search button

    const searchtxt = () => {
        getreports(searchtext, 1, getLimit);
    }
    //pagiantion

    const Pagination = ({ currentPage, totalPages, onPageChange }) => {
        const pages = [];
        for (let i = 1; i <= totalPages; i++) {
            pages.push(i);
        }
        console.log(currentPage, 'current pages...')
        return (
            <div className="pagination">
                {currentPage > 1 && (
                    <button className="pagination-btn" onClick={() => onPageChange(currentPage - 1)}>
                        <i className="fa fa-chevron-left" aria-hidden="true"></i>
                    </button>
                )}
                {startPage > 1 && (
                    <button className="pagination-btn" onClick={() => onPageChange(1)}>
                        1
                    </button>
                )}
                {startPage > 2 && <span className="pagination-ellipsis">...</span>}
                {pages.slice(startPage - 1, endPage).map(page => (
                    <button
                        key={page}
                        className={`pagination-btn ${page === currentPage ? 'active' : ''}`}
                        onClick={() => onPageChange(page)}
                    >
                        {page}
                    </button>
                ))}
                {endPage < totalPages - 1 && <span className="pagination-ellipsis">...</span>}
                {endPage < totalPages && (
                    <button className="pagination-btn" onClick={() => onPageChange(totalPages)}>
                        {totalPages}
                    </button>
                )}
                {currentPage < totalPages && (
                    <button className="pagination-btn" onClick={() => onPageChange(currentPage + 1)}>
                        <i className="fa fa-chevron-right" aria-hidden="true"></i>
                    </button>
                )}
            </div>
        );
    };
    // get reports
    const getreports = async (search_name, pagecount, limit, from_date, to_date) => {
        try {
            const result = await httpClient.post('/admin/member-reports-list', {
                search_name, offset: pagecount, limit: limit,
                from_date: from_date,
                to_date: to_date
            }, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            if (result.status === 200) {
                let week_arr = []
                console.log(result.data.data, 'data..')
                setTotalCount(result?.data.total_count)
                setReportslist(result?.data?.data)
                const weeklyArrayWithKeys = Object.entries(result?.data?.weekly_report_data).map(([key, value]) => ({
                    key,
                    ...value,

                }));
                console.log(weeklyArrayWithKeys, 'weekl;udad////')
                setweeklyData(weeklyArrayWithKeys)
                // setweeklyData(result?.data?.weekly_report_data)
            }

        } catch (error) {
            //   toast.error(error.message)
        }
    }

    function fetchWeeklyDatalist(weekData) {
        // Step 1: Split the string by " - "
        const input = "28 Apr - 04 May";

        // Month short to number mapping
        const monthMap = {
            Jan: 1,
            Feb: 2,
            Mar: 3,
            Apr: 4,
            May: 5,
            Jun: 6,
            Jul: 7,
            Aug: 8,
            Sep: 9,
            Oct: 10,
            Nov: 11,
            Dec: 12
        };

        // Step 1: Split the string by " - "
        const parts = weekData?.date?.split(" - "); // ["28 Apr", "04 May"]

        // Step 2: Split each part into day and short month
        const [startDay, startMonthShort] = parts[0].split(" ");
        const [endDay, endMonthShort] = parts[1].split(" ");

        // Step 3: Convert day/month to 2-digit string
        let startmonth = String(monthMap[startMonthShort]).padStart(2, '0')
        let endmonth = String(monthMap[endMonthShort]).padStart(2, '0')
        const startDate = `2025-${parseInt(startmonth)}-${parseInt(startDay.padStart(2, '0'))}`
        const endDate = `2025-${parseInt(endmonth)}-${parseInt(endDay.padStart(2, '0'))}`



        getreports(searchtext, currentPage, getLimit, startDate, endDate)


    }

    const viewIncome = (e) => {
        let paginationState = {
            pageCurrent: currentPage,
            limit: getLimit,

        }
        navigate(`/memberincome?id=${e?.id}`,
            {
                state: {
                    paginationState
                }
            }

        );
        //  localStorage.setItem('editSubData',editSub)
    }
    const viewTeam = (e) => {
        console.log(e);
        let paginationState = {
            pageCurrent: currentPage,
            limit: getLimit,

        }
        // const editSub = JSON.stringify(e)
        navigate(`/member-teamdetails?id=${e?.id}`,

            {
                state: {
                    paginationState
                }
            }
        );
        //  localStorage.setItem('editSubData',editSub)
    }

    const editItem = (e) => {
        // console.log(e);
        let paginationState = {
            pageCurrent: currentPage,
            limit: getLimit,

        }
        navigate(`/memberprofile-details?id=${e?.id}`, {
            state: {
                paginationState
            }
        });
        //  localStorage.setItem('editSubData',editSub)
    }
    // debounce function to limit the number of API calss
    function debounce(func, delay) {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => func(...args), delay);
        };
    }
    // search handler function
    const searchHandler = debounce((query) => {
        getreports(query, currentPage, getLimit)
    }, 2000)
    return (
        <>
            <div className="">

                <div class="search-box">
                    <div class="searchtct">

                        <i class="fa fa-search" aria-hidden="true"></i>
                        <input type="text" name="text" placeholder="Search..."
                            onChange={(val) => searchHandler(val.target.value)}
                        // onKeyDown={() => {
                        //     if (searchtext === '') {
                        //         getreports(searchtext, currentPage, getLimit)
                        //     }
                        // }}
                        />
                        {/* <button type='button' className='searchBtn' onClick={searchtxt} >Search</button> */}


                    </div>

                </div>
                <h4>Weekly Report: {totalCount}</h4>

                <div class="row weekly-padinig-box">
                    {
                        weeklyData?.map((item) => {
                            return (

                                <div
                                    style={{
                                        backgroundColor: item?.date == activeWeekly?.date ? '#03cafc' : ''
                                    }}
                                    class="col-md-3 weekly-box"
                                    onClick={() => {
                                        fetchWeeklyDatalist(item)
                                        setactiveweek(item)
                                    }}
                                >
                                    <div>
                                        <u className="price-profit">{item?.key}</u>
                                        <p className="price-profit">{item?.date}</p>
                                        <p className="price-profit">
                                            {/* <i className="fa fa-inr ml-2" /> */}
                                            {/* {item?.total_price} */}
                                        </p>
                                    </div>
                                </div>

                            )
                        })
                    }
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>SL NO</th>
                                        <th> Member ID</th>
                                        <th>Name</th>
                                        {/* <th>Validity</th>
                <th >Description</th> */}
                                        {/* <th>Discount</th>
                <th>Price</th> */}
                                        <th>Refered ID</th>
                                        <th>Mobile</th>
                                        <th>Address</th>
                                        <th>Joing Date</th>
                                        <th>Member Status</th>
                                        <th>Position</th>
                                        <th>Income</th>
                                        <th>Profile</th>
                                        <th>Team</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {
                                        rportsList?.map((item, index) => {
                                            const serialNumber = (currentPage - 1) * getLimit + index + 1;

                                            return (
                                                <>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                backgroundColor: item?.phone == null ? 'gray' : 'transparent',
                                                                color: item?.phone == null ? 'white' : 'black'
                                                            }}
                                                        >{serialNumber}</td>
                                                        <td style={{
                                                            backgroundColor: item?.phone == null ? 'gray' : 'transparent',
                                                            color: item?.phone == null ? 'white' : 'black'
                                                        }}>{item?.member_code}</td>
                                                        <td style={{
                                                            backgroundColor: item?.phone == null ? 'gray' : 'transparent',
                                                            color: item?.phone == null ? 'white' : 'black'
                                                        }}>{item?.name}</td>
                                                        <td style={{
                                                            backgroundColor: item?.phone == null ? 'gray' : 'transparent',
                                                            color: item?.phone == null ? 'white' : 'black'
                                                        }} >
                                                            {/* < TooltipManager
                                                            selector=".reffered-td"
                                                            data={memberlist}
                                                            index={index}
                                                            getMessage={(el) => `${item?.referred_by != [] ? memberlist[index]?.referred_by?.name : ''}`}
                                                        /> */}
                                                            <ReactTooltip
                                                                id={item?.member_code}
                                                                place="bottom"
                                                                content={() => {
                                                                    return <div style={{
                                                                        padding: 0,
                                                                        margin: 0,
                                                                    }}>
                                                                        <p style={{
                                                                            padding: 0,
                                                                            margin: 0
                                                                        }}>{item?.referred_by != [] ? item?.referred_by?.name : ''}</p>
                                                                        {
                                                                            item?.status == 0 && (
                                                                                <p style={{
                                                                                    color: 'red', padding: 0, margin: 0, textAlign: 'center'
                                                                                }}>Block</p>

                                                                            )
                                                                        }

                                                                    </div>
                                                                }}

                                                            />
                                                            {/* <ReactTooltip
                                                            id={item?.phone}
                                                            place='bottom'
                                                            content={item?.referred_by != [] ? item?.referred_by?.name : ''}

                                                        />
                                                        <p data-tooltip-id={item?.phone}></p> */}
                                                            <div data-tooltip-id={item?.member_code} >
                                                                {item?.referred_by != [] ? item?.referred_by?.user_referral_code : ''}
                                                            </div>
                                                        </td>
                                                        {/* <td>{item?.referred_by != [] ? item?.referred_by?.user_referral_code : ''}</td> */}
                                                        <td style={{
                                                            backgroundColor: item?.phone == null ? 'gray' : 'transparent',
                                                            color: item?.phone == null ? 'white' : 'black'
                                                        }}>{item?.phone}</td>
                                                        <td style={{
                                                            backgroundColor: item?.phone == null ? 'gray' : 'transparent',
                                                            color: item?.phone == null ? 'white' : 'black'
                                                        }} className='address-td text_view'>{item?.address !== null ? item?.address : '--'}</td>
                                                        <td style={{
                                                            backgroundColor: item?.phone == null ? 'gray' : 'transparent',
                                                            color: item?.phone == null ? 'white' : 'black'
                                                        }}>{moment(item?.joing_date).format('DD-MM-YYYY')}</td>
                                                        <td style={{
                                                            backgroundColor: item?.phone == null ? 'gray' : 'transparent',
                                                            color: item?.phone == null ? 'white' : 'black'
                                                        }}>
                                                            <span className={item?.active == 1 ? "active" : "inactive"}>{item?.active == 1 ? "Active" : "Inactive"}</span>

                                                            {
                                                                item?.active_date && (<p className='member-expiridata'
                                                                    style={{
                                                                        padding: 0,
                                                                        margin: 0,
                                                                    }}
                                                                >{

                                                                        moment(item?.active_date).format('DD-MM-YYYY')

                                                                    }</p>)
                                                            }
                                                            {
                                                                item?.status == 0 && (
                                                                    <p style={{
                                                                        color: 'red',
                                                                        padding: 0,
                                                                        margin: 0,
                                                                        textAlign: 'center',
                                                                        marginRight: '20px'
                                                                    }}>Block</p>

                                                                )
                                                            }

                                                        </td>
                                                        <td style={{
                                                            backgroundColor: item?.phone == null ? 'gray' : 'transparent',
                                                            color: item?.phone == null ? 'white' : 'black'
                                                        }} className='position_td'>
                                                            {/* <div style={{
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            backgroundColor:'red'


                                                        }}> */}



                                                            <p>
                                                                {item?.added_profile_count != null ? `Profile Added--${item?.added_profile_count}` : "--"}
                                                            </p>
                                                            <p> {item?.used_profile_count != null ? `Service Used--${item?.used_profile_count}` : "--"}

                                                            </p>





                                                            {/* </div> */}
                                                        </td>
                                                        <td style={{
                                                            backgroundColor: item?.phone == null ? 'gray' : 'transparent',
                                                            color: item?.phone == null ? 'white' : 'black'
                                                        }} >
                                                            <div className='table-column'>
                                                                <i
                                                                    style={{
                                                                        // width:60,
                                                                        fontSize: 20
                                                                        // height:60
                                                                    }}

                                                                    onClick={() => viewIncome(item)}
                                                                    class="fa fa-money team-incom" aria-hidden="true"></i>
                                                            </div>


                                                        </td>
                                                        <td style={{
                                                            backgroundColor: item?.phone == null ? 'gray' : 'transparent',
                                                            color: item?.phone == null ? 'white' : 'black'
                                                        }}>
                                                            <div className='table-column'>
                                                                <i
                                                                    style={{
                                                                        fontSize: 20
                                                                    }}
                                                                    onClick={() => editItem(item)}
                                                                    class="fa fa-user team-incom" aria-hidden="true"></i>
                                                            </div>
                                                        </td>
                                                        <td style={{
                                                            backgroundColor: item?.phone == null ? 'gray' : 'transparent',
                                                            color: item?.phone == null ? 'white' : 'black'
                                                        }}>
                                                            <div className='table-column'>
                                                                <i
                                                                    style={{
                                                                        fontSize: 20
                                                                    }}
                                                                    onClick={() => viewTeam(item)}

                                                                    class="fa fa-group team-incom" aria-hidden="true"></i>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </>
                                            )
                                        })
                                    }

                                </tbody>

                            </table>
                            <div className='nodata-found-div'>
                                {
                                    rportsList?.length == 0 ?
                                        <p>No Data Found</p>
                                        //  <img 
                                        //  className='table-image'
                                        //  src={require('../../assets/OIP.png')}/>
                                        : null
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tablepgntn">
                    <p>Show <select value={getLimit} onChange={(val) => {
                        setLimit(val.target.value);
                        setCurrentPage(1)
                    }}>
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={30}>30</option>
                        <option value={40}>40</option>
                        <option value={50}>50</option>
                    </select> Entries</p>
                    <ul>

                    </ul>
                    <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                    />

                </div>

            </div>

        </>
    )
}
export default Reports